





























































































































































































import { Component } from 'vue-property-decorator';
import dayjs from 'dayjs';

import AdminService from '@/api/AdminService';

import RowsTable from '@/components/Table/RowsTable.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import { HeaderList } from '@/components/Table/TableModel';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContextMenuOption from '@/components/ContextMenu/ContextMenuOption';
import TemplateModal from '@/components/TemplateModal/TemplateModal.vue';
import Modal from '@/components/Modal/Modal.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import { TextField } from '@/components/atoms';
import Typography from '@/components/atoms/Typography/Typography.vue';
import DateFilter from '@/components/molecules/DateFilter/DateFilter.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Row from '@/components/atoms/Grid/Row.vue';
import Cell from '@/components/atoms/Grid/Cell.vue';
import Container from '@/components/atoms/Grid/Container.vue';
import {
  CustomSelectGroup,
  CustomSelectModel,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';

import DateUtils from '@/utils/DateUtils';
import eventBus from '@/utils/eventBus';
import { openCenterModal } from '@/utils/modal';

import { IPeriod } from '@/models/period';
import { ECoinStatus, ERefundStatus } from '@/models/transaction';
import { treatError } from '@/utils';
import { EBusinessProviders } from '@/components/BusinessTypeSelector/business-providers.enum';
import jwtDecode from 'jwt-decode';
import APIService from '@/api';

@Component({
  components: {
    Modal,
    TemplateModal,
    Table,
    FlexButton,
    RowsTable,
    CustomSelect,
    TextInput,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    ContextMenu,
    TableFilters,
    TextField,
    Typography,
    DateFilter,
    Page,
    FilledButton,
    Row,
    Cell,
    Container
  }
})
export default class TransactionsList extends BasePagination {
  service = new AdminService();
  providerFilterModel: any = [];
  typeEventFilterModel: any = [];
  period: IPeriod = this.initialPeriod;
  time: { extras?: string } = {};
  searchableFields =
    'searchableFields=business.name&searchableFields=customer.name';
  filterValuesSeparator = ':';
  confirmationModal = {
    show: false,
    loading: false,
    text: '',
    onConfirm: () => null
  };
  targetClassForInfineScroll = '.container-scrollable';
  superAdminEmail = '';
  canMakeManuallyReward = false;

  created() {
    this.initSuperAdminEmail();
    this.initProviderFilterModel();
    this.initFilterFakeEvent();
  }

  initSuperAdminEmail() {
    const token = localStorage.getItem(
      `${window.location.host}-${APIService.SUPER_ADMIN}`
    );
    this.superAdminEmail = jwtDecode(token).extraInfo.mail;
    this.setCanMakeManuallyReward();
  }

  getProviderLogo(provider: string) {
    const imgMap: Record<string, string> = {
      bigcommerce: '/img/bigcommerce.svg',
      wix: '/img/wix.svg',
      shopify: '/img/shopify.svg',
      woocommerce: '/img/woocommerce.svg',
      square: '/img/square.svg',
      fidel: '/img/fidel.svg',
      twism: '/img/twism.png'
    };

    return imgMap[provider] || '';
  }

  getCardType(cardType: string) {
    switch (cardType) {
      case 'master':
        return 'mastercard';

      default:
        return cardType;
    }
  }

  getOptions(transaction: any) {
    const options: ContextMenuOption[] = [
      {
        action: 'internalData',
        label: 'Internal Data'
      },
      {
        action: 'externalData',
        label: 'External Data'
      }
    ];
    if (
      transaction.coinsStatus === ECoinStatus.PENDING &&
      !transaction.refundStatus
    ) {
      options.push({
        action: 'clear',
        label: 'Clear'
      });
    }

    if (
      transaction.coinsStatus !== ECoinStatus.READY &&
      transaction.refundStatus !== ERefundStatus.TOTAL
    ) {
      options.push({
        action: 'refund',
        label: 'Refund'
      });
    }

    if (
      !this.isProduction &&
      transaction.provider === EBusinessProviders.FIDEL
    ) {
      options.push({
        action: 'fake-fidel-transaction',
        label: 'Fake Fidel transaction'
      });
    }
    return options;
  }

  async showTransactionExternalData(transactionId: string) {
    try {
      const { data, status } = await this.service.getTransactionExternalData(
        transactionId
      );

      if (status === 200) {
        return this.detail(data);
      }
    } catch (error) {
      this.$notification(treatError(error));
    }
  }

  runAction(action: string, props: any, transaction: any) {
    switch (action) {
      case 'internalData':
        return this.detail(transaction.rawData);
      case 'externalData':
        return this.showTransactionExternalData(transaction.rawData.id);
      case 'clear':
      case 'refund':
        eventBus.$once('closeModal', () => this.reloadList(true));
        openCenterModal('transactionActionConfirmationModal', {
          action,
          transaction
        });
        break;
      case 'fake-fidel-transaction':
        this.showModalWebhookFakeFidel(transaction);
        break;
    }
  }

  showModalWebhookFakeFidel(transaction?: any) {
    const modalConfig = {
      isOpen: true,
      component: 'webhookFakeFidel',
      width: '50vw',
      data: transaction
    };

    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  showModalManuallyReward(transaction?: any) {
    const modalConfig = {
      isOpen: true,
      component: 'manuallyReward',
      width: '50vw',
      data: transaction
    };

    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  showPendingCoinsVerifierModal() {
    eventBus.$emit('setSideModalVisible', {
      isOpen: true,
      component: 'pendingCoinsVerifier',
      width: '50vw',
      data: {}
    });
  }

  detail(event: any) {
    const modalConfig = {
      isOpen: true,
      component: 'adminOnlineTransactions',
      data: event,
      width: '60vw'
    };

    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  initHeader() {
    return [
      new HeaderList(`Business name`, 'business.name', '12px 4px 12px 24px'),
      new HeaderList(`Customer name`, 'customer.name', '12px 4px'),
      new HeaderList(`Provider`, 'connectTransaction.provider', '12px 4px'),
      new HeaderList(`Status`, 'connectTransaction.status', '12px 4px'),
      new HeaderList(`IsClearLate`, 'isClearLate', '12px 4px'),
      new HeaderList(
        `Amount`,
        'connectTransaction.baseMoneyAmount',
        '12px 4px'
      ),
      new HeaderList(`Coins`, 'connectTransaction.coinsAmount', '12px 4px'),
      new HeaderList(`Loyalty`, 'connectTransaction.coinsStatus', '12px 4px'),
      new HeaderList(`Refund`, 'connectTransaction.refundStatus', '12px 4px'),
      new HeaderList(`Card`, 'connectTransaction.cardBrand', '12px 4px'),
      new HeaderList(`CreatedAt`, 'connectTransaction.createdAt', '12px 4px'),
      new HeaderList(`UpdatedAt`, 'connectTransaction.updatedAt', '12px 4px'),
      new HeaderList(``, 'none', '12px 24px 12px 4px')
    ];
  }

  initFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('authorized', `Authorized`),
      new CustomSelectOption('cleared', `Cleared`),
      new CustomSelectOption('provisional', `Provisional`)
    ]);

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by status`,
      false,
      true,
      true,
      false
    );
  }

  initProviderFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('wix', `Wix`),
      new CustomSelectOption('fidel', `Fidel`),
      new CustomSelectOption('square', `Square`),
      new CustomSelectOption('shopify', `Shopify`),
      new CustomSelectOption('bigcommerce', `Bigcommerce`),
      new CustomSelectOption('woocommerce', `Woocommerce`)
    ]);

    this.providerFilterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by provider`,
      false,
      true,
      true,
      false
    );
  }

  initFilterFakeEvent() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('true', `Fake event`),
      new CustomSelectOption('false', `Real event`)
    ]);

    this.typeEventFilterModel = new CustomSelectModel(
      [actionGroup],
      `Filter type event`,
      false,
      true,
      true,
      false
    );
  }

  addRowsList(data: any[]): any[] {
    return data.map((row: any) => ({
      id: row.id,
      cardType: row.cardBrand || '',
      cardNumber: row.cardLast4 || 'Not informed',
      amount: `${row.countryRelationship.currencySymbol}${this.centsToDollar(
        row.moneyAmount
      )}`,
      businessName: row.business.name,
      provider: row.provider,
      customerName: row.customer.id
        ? `${row.customer.name} ${row.customer.lastname}`
        : '--',
      status: row.status,
      coinsStatus: row.coinsStatus,
      coinsNotGivenReason: row.coinsNotGivenReason,
      refundStatus: row.refundStatus,
      isClearLate: row.isClearLate,
      coinsAmount: (row.coinsAmount / 100).toFixed(2),
      updatedAt: DateUtils.formatISODate(row.updatedAt, true),
      createdAt: DateUtils.formatISODate(row.createdAt, true),
      rawData: row
    }));
  }

  centsToDollar(centsValue: number) {
    return centsValue / 100;
  }

  treatCardNumber(cardNumber: string) {
    return cardNumber
      .split('-')
      .splice(2, 2)
      .join(' ')
      .replace(/X/g, '•');
  }

  async reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string
  ) {
    this.sortField = this.sortField || 'connectTransaction.createdAt';
    this.sortOrder = this.sortOrder || 'DESC';

    if (clearList) {
      this.resetPagination();
      this.dataList.list = [];
      this.maxItems = false;
    }

    if (this.refreshing || this.maxItems) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;

    try {
      const response = await this.service.getProvidersTransactions({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: decodeURIComponent(this.pagination),
        filters: this.query,
        period: {
          from: this.period.start,
          to: this.period.end
        }
      });
      const { data } = response;
      const { items, links } = data;
      if (refreshCurrent) {
        // refresh page and reinitilize pagination
        this.resetPagination();
        this.pagination = links.next;
        if (!links.next) this.maxItems = true;
        this.dataList.list = this.addRowsList(items);
      } else {
        // refresh page and add items
        if (!links.next) this.maxItems = true;
        this.pagination = links.next;
        this.dataList.list = this.dataList.list.concat(this.addRowsList(items));
      }

      this.$hideLoader();
      this.isLoading = true;
      this.refreshing = false;
    } catch (e) {
      console.error(e);
      this.$hideLoader();
    }
  }

  onPeriodInput(newPeriod: IPeriod) {
    this.period = newPeriod;
    this.reloadList(true, true);
  }

  setCanMakeManuallyReward() {
    const emailsAllowed = [
      'ben.corral@twism.com',
      'otavio.avila@twism.com',
      'daniel.souza@twism.com',
      'muller.lemos@twism.com'
    ];
    this.canMakeManuallyReward = emailsAllowed.includes(this.superAdminEmail);
  }

  get getLabelByPeriod() {
    const { start, end } = this.period;
    const format = (date: string) => DateUtils.formattedDate({ date });

    return `${format(start)} - ${format(end)}`;
  }

  get initialPeriod() {
    return {
      end: dayjs()
        .utc()
        .toISOString(),
      start: dayjs()
        .utc()
        .add(-7, 'days')
        .toISOString(),
      shortcut: ''
    };
  }

  get interval() {
    return {
      to: this.period.end,
      from: this.period.start
    };
  }

  get isProduction() {
    return window.location.host === 'dashboard.twism.com';
  }

  getClassIsClearLateColor(isClearLate: string) {
    switch (isClearLate) {
      case '1+ day delay':
        return 'alert';
      case '7+ day delay':
        return 'danger';
      default:
        return 'normal';
    }
  }

  getClassOpacityisCleared(status: string) {
    if (status === 'cleared') {
      return 'cleared';
    }
    return '';
  }

  getTransactionStatus(transaction: any) {
    if (transaction.status === 'cleared') {
      const isManualClearLabel = transaction.isManualClear ? '(Manual)' : '';
      return `${transaction.status} ${isManualClearLabel}`;
    }
    return transaction.status;
  }
}
